import React from "react";
import { FormControlLabel, Box, Typography, Stack } from "@mui/material";
import { CustomInput } from "@dishopsaas/design-system";

import getStyles from "../AddressInput.styles";
import { getAddressFormatted } from "../../../utils";
import { ORDER_TYPE_DELIVERY } from "../../../constants";
import { AddressSelectionRadioButtonsProps } from "../../../1_types/AddressInputTypes";
import { getColors } from '../../../utils'
interface RadioItemProps {
  checked: boolean;
  disabled: boolean;
  title: string;
  description: string;
  onChange: () => void;
}
const styles = getStyles()
const RadioItem = ({
  checked,
  disabled,
  title,
  description,
  onChange,
}: RadioItemProps) => (
  <FormControlLabel
    label=""
    control={
      <>
        <CustomInput
          type="radio"
          checked={checked}
          disabled={disabled}
          onChange={onChange}
        />
        <Box sx={styles.radioLabelWrapperSx}>
          <Box sx={styles.radioContentSx}>
            <Box sx={styles.textContainerSx}>
              <Typography variant="body1" sx={styles.label}>
                {title}
              </Typography>

              <Stack
                direction="row"
                alignItems="center"
                spacing={0.5}
                sx={styles.descriptionStackSx}
              >
                <Typography variant="caption" sx={styles.descriptionTextSx}>
                  {description}
                </Typography>
              </Stack>
            </Box>
          </Box>
        </Box>
      </>
    }
  />
);

export default function AddressSelectionRadioButtons({
  isCustomerAddress,
  handleAddressTypeSelection,
  getShopsIsLoading,
  savedAddress,
  orderType,
}: AddressSelectionRadioButtonsProps) {
  const handleChange = (value: boolean) => {
    handleAddressTypeSelection({
      target: { value: String(value) },
    });
  };

  return (
    <Box sx={styles.containerSx}>
      <RadioItem
        checked={isCustomerAddress === true}
        disabled={getShopsIsLoading}
        onChange={() => handleChange(true)}
        title="Adresse enregistrée"
        description={getAddressFormatted(savedAddress)}
      />

      <hr
        style={{
          margin: "8px 0",
          border: "none",
          borderTop: getColors().border,
        }}
      />

      <RadioItem
        checked={isCustomerAddress === false}
        disabled={getShopsIsLoading}
        onChange={() => handleChange(false)}
        title="Saisir une nouvelle adresse"
        description={
          orderType === ORDER_TYPE_DELIVERY
            ? "Saisir une nouvelle adresse de livraison"
            : "Saisir l'adresse de votre magasin"
        }
      />
    </Box>
  );
}
